class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    $(".cart-notification-wrapper").addClass("is-opened");
    $('body').addClass("overflow-hidden");
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    $(".cart-notification-wrapper").removeClass("is-opened");
    $('body').removeClass("overflow-hidden");
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }
  renderContents(parsedState) {
    // this.cartItemKey = parsedState.key;
   // to get cart item key of main product
    var cartItemKey = "";
    var currentProductVariant_id = $(document).find('.product-variant-id[name="items[0][id]"]').val();
    console.log(currentProductVariant_id);
     fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
        // console.log(data);
        $.each(data.items, function (key, value) {
          var itemKey = value.key;
          if(itemKey.includes(currentProductVariant_id)){
            console.log(itemKey);
            cartItemKey = itemKey;
          }
        });
      });
  
       setTimeout(() => { 

          this.cartItemKey = cartItemKey;
          console.log("this.cartItemKey => " + this.cartItemKey);
          // this.getSectionsToRender().forEach((section) => {
          //   document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          //     parsedState.sections[section.id],
          //     section.selector
          //   );
          // });
           this.getSectionsToRender().forEach((section) => {
          if (parsedState.sections[section.id]) {
            const sectionHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            const targetElement = document.getElementById(section.id);
      
            if (targetElement) {
              targetElement.innerHTML = sectionHTML;
            }
          }
        });
      
          if (this.header) this.header.reveal();
          // var $this = this;
              this.open();
          // setTimeout(function(){
          // },1200);
        }, 1000);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        // selector: '#shopify-section-cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  // getSectionInnerHTML(html, selector = '.shopify-section') {
  //   return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  // }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const sectionElement = doc.querySelector(selector);
  
    return sectionElement ? sectionElement.innerHTML : '';
  }


  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

